// import axios from "axios";
import { Input } from "@mui/icons-material";
import * as api from "./api";

// const BASE_URL = "http://localhost:4000";

export const LoginAPI = async (data) => {
  // const response = await axios.post(`${BASE_URL}/sign-in`, data);
  // return response;

  const res = await api.request({
    url: "/admin/sign-in",
    method: "POST",
    data,
  });
  return res;
};

export const getUsersAPI = async ({
  page,
  fullName,
  city,
  occupation,
  maritalStatus,
  sort,
}) => {
  // const token = localStorage.getItem("token");
  // const headers = { Authorization: token };
  // const response = await axios.get(`${BASE_URL}/users?fullName=${fullName}`, {
  //   headers,
  // });
  // return response;
  const res = await api.request({
    url: `/admin/users?page=${page}&fullName=${fullName}&city=${city}&occupation=${occupation}&maritalStatus=${maritalStatus}&sort=${sort}`,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const userActivityAPI = async ({ id }) => {
  const res = await api.request({
    url: `/admin/active-users/${id}`,
    method: "PUT",
  });
  return res;
  // const token = localStorage.getItem("token");
  // const headers = { Authorization: `Bearer ${token}` };
  // const response = await axios.post(
  //   `${BASE_URL}/active-users/${id}`,
  //   {},
  //   {
  //     headers,
  //   }
  // );
  // return response.data;
};

export const updateUserAPI = async ({ id, ...formData }) => {
  const res = await api.request({
    url: `/admin/users/?userId=${id}`,
    method: "PUT",
    data: formData,
  });

  return res;
};

export const getUserDetailsAPI = async ({ id }) => {
  const res = await api.request({
    url: `/admin/get-user?userId=${id}`,
    method: "GET",
  });
  return res;
};
export const getAllInactiveUser = async ({ page,
  fullName,
  city,
  occupation,
  maritalStatus,
  sort, 
}) => {
  const res = await api.request({
    url: `/admin/active?page=${page}&fullName=${fullName}&city=${city}&occupation=${occupation}&maritalStatus=${maritalStatus}&sort=${sort}`,
    method: "GET",
  });
  return res;
};

export const getAdminDetailsAPI = async () => {
  const res = await api.request({
    url: "/admin/me",
    method: "GET",
  });
  return res;
};

export const getUsersCountAPI = async () => {
  const res = await api.request({
    url: `/admin/users-count`,
    method: "GET",
  });
  return res;
};

export const removeUserAPI = async ({ id }) => {
  const res = await api.request({
    url: `/admin/remove-user/${id}`,
    method: "PUT",
  });
  return res;
};

export const getRemovedUsersAPI = async () => {
  const res = await api.request({
    url: `/admin/removed-users`,
    method: "GET",
  });
  return res;
};

export const restoreUserAPI = async ({ id }) => {
  const res = await api.request({
    url: `/admin/restore-user/${id}`,
    method: "PUT",
  });
  return res;
};

export const createLanguageAPI = async ({ original, en, hi }) => {
  const res = await api.request({
    url: "/admin/translation",
    method: "POST",
    data: {
      original,
      en,
      hi,
    },
  });
  return res;
};

export const getTranslationsAPI = async () => {
  const res = await api.request({
    url: `/admin/translation`,
    method: "GET",
  });
  return res;
};

export const createPatrikaPdf = async (formData) => {
  const res = await api.request({
    method: "POST",
    data: formData,
    url: "/admin/patrika",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res;
};

export const getAllPatrikaRequest = async (formData) => {
  const res = await api.request({
    method: "GET",
    data: formData,
    url: "/admin/patrika",
  });

  return res;
};

export const updatePatrikaFile = async (id, formData) => {
  const res = await api.request({
    url: `/admin/patrika/${id}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res;
};


export const deletePatrikaFile = async (id) => {
  const res = await api.request({
    url: `/admin/patrika/${id}`,
    method: "DELETE",
  });

  return res;
};

export const createAdminNotification = async ({ formValues }) => {
  const res = await api.request({
    url: "/admin/notification",
    method: "POST",
    data: formValues,
  });

  return res;
};

export const getAllAdminNotification = async () => {
  const res = await api.request({
    url: "/admin/notification",
    method: "GET",
  });

  return res;
};

export const updateAdminNotification = async (id, { formValues }) => {
  const res = await api.request({
    url: `/admin/notification/${id}`,
    method: "Put",
    data: formValues,
  });
  return res;
}

export const deleteAdminNotification = async (id) => {
  const res = await api.request({
    url: `/admin/notification/${id}`,
    method: "DELETE",
  });

  return res;
};

export const createQuotes = async ({ formValues }) => {
  const res = await api.request({
    url: "/admin/quotes",
    method: "POST",
    data: formValues,
  });

  return res;
};

export const getAllQuotes = async () => {
  const res = await api.request({
    url: "/admin/quotes",
    method: "GET",
  });

  return res;
};
export const getAllStates = async () => {
  const res = await api.request({
    url: "/admin/all-states",
    method: "GET",
  });

  return res;
};
export const getAllCities = async (stateId) => {
  const res = await api.request({
    url: `/admin/all-cities?id=${stateId}`,
    method: "GET",
  });

  return res;
};

export const getAllCity = async () => {
  const res = await api.request({
    url: `/get-all-cities`,
    method: "GET",
  });

  return res;
};

export const updateDailyQuotes = async ({ id, formValues }) => {
  const res = await api.request({
    url: `/admin/quotes/${id}`,
    method: "PATCH",
    data: formValues,
  });

  return res;
};


export const deleteDailyQuotes = async (id) => {
  const res = await api.request({
    url: `/admin/quotes/${id}`,
    method: "DELETE",
  });

  return res;
};